import { render, staticRenderFns } from "./LanguageSelectorDropdown.vue?vue&type=template&id=1dbb2cba"
import script from "./LanguageSelectorDropdown.vue?vue&type=script&lang=js"
export * from "./LanguageSelectorDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dbb2cba')) {
      api.createRecord('1dbb2cba', component.options)
    } else {
      api.reload('1dbb2cba', component.options)
    }
    module.hot.accept("./LanguageSelectorDropdown.vue?vue&type=template&id=1dbb2cba", function () {
      api.rerender('1dbb2cba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Emulator/LanguageSelectorDropdown.vue"
export default component.exports